import { render, staticRenderFns } from "./VxSynchronizationAlerts.vue?vue&type=template&id=33adf15a"
import script from "./VxSynchronizationAlerts.vue?vue&type=script&lang=js"
export * from "./VxSynchronizationAlerts.vue?vue&type=script&lang=js"
import style0 from "./VxSynchronizationAlerts.vue?vue&type=style&index=0&id=33adf15a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports